var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "审核",
        visible: _vm.dialogVisible,
        width: "506px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c("div", { staticClass: "btn" }, [
            _c(
              "div",
              {
                class: ["flex_c_c", !_vm.active && "active"],
                on: {
                  click: function ($event) {
                    return _vm.confirm(0)
                  },
                },
              },
              [_vm._v("系统自动合并")]
            ),
            _c(
              "div",
              {
                class: ["flex_c_c", _vm.active && "active"],
                on: {
                  click: function ($event) {
                    return _vm.confirm(1)
                  },
                },
              },
              [_vm._v("手动合并")]
            ),
          ]),
          _vm.active === 0
            ? _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "品名数量", prop: "quantity" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 1,
                              step: 1,
                            },
                            model: {
                              value: _vm.form.quantity,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "quantity", $$v)
                              },
                              expression: "form.quantity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "最小税金", prop: "taxAmountMin" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 1,
                              step: 2,
                            },
                            model: {
                              value: _vm.form.taxAmountMin,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "taxAmountMin", $$v)
                              },
                              expression: "form.taxAmountMin",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "最大税金", prop: "taxAmountMax" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 1,
                              step: 2,
                            },
                            model: {
                              value: _vm.form.taxAmountMax,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "taxAmountMax", $$v)
                              },
                              expression: "form.taxAmountMax",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }